import React from 'react';
import Link from 'next/link';
import Image from 'next/image';
import AppLogo from '@/components/ui/AppLogo';
import {
  Phone,
  Mail,
  MapPin,
  Clock,
  ArrowRight } from
'lucide-react';

const socialLinks = [
{
  label: 'Facebook',
  href: '#',
  icon:
  <svg viewBox="0 0 24 24" fill="currentColor" width="14" height="14">
        <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
      </svg>

},
{
  label: 'Instagram',
  href: '#',
  icon:
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="14" height="14">
        <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
        <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
        <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
      </svg>

},
{
  label: 'YouTube',
  href: '#',
  icon:
  <svg viewBox="0 0 24 24" fill="currentColor" width="14" height="14">
        <path d="M22.54 6.42a2.78 2.78 0 0 0-1.95-1.96C18.88 4 12 4 12 4s-6.88 0-8.59.46A2.78 2.78 0 0 0 1.46 6.42 29 29 0 0 0 1 12a29 29 0 0 0 .46 5.58 2.78 2.78 0 0 0 1.95 1.96C5.12 20 12 20 12 20s6.88 0 8.59-.46a2.78 2.78 0 0 0 1.95-1.96A29 29 0 0 0 23 12a29 29 0 0 0-.46-5.58z" />
        <polygon fill="white" points="9.75 15.02 15.5 12 9.75 8.98 9.75 15.02" />
      </svg>

},
{
  label: 'Twitter / X',
  href: '#',
  icon:
  <svg viewBox="0 0 24 24" fill="currentColor" width="14" height="14">
        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
      </svg>

}];


const branches = [
{ name: 'FIFTY ONE PLUS LAB — Sector 51, Noida', address: 'H-56, Sector 51, Noida, UP 201301' }];



const quickLinks = [
{ label: 'Health Packages', href: '/health-packages' },
{ label: 'Book Appointment', href: '/book-appointment' },
{ label: 'Home Collection', href: '#' },
{ label: 'Corporate Checkups', href: '#' },
{ label: 'Speciality Doctors', href: '#' },
{ label: 'Upload Prescription', href: '#' },
{ label: 'Patient Portal', href: '#' },
{ label: 'Corporate Portal', href: '#' }];


const services = [
'Advanced Pathology',
'ECG & 2D Echo',
'Ultrasound',
'X-Ray',
'Audiometry',
'PFT',
'Mammography',
'Endoscopy',
'Annual Health Checkups',
'Pre-Employment Medical'];


export default function Footer() {
  return (
    <footer className="bg-foreground text-white">
      {/* Footer hero image strip */}
      <div className="relative h-48 overflow-hidden">
        <Image
          src="https://img.rocket.new/generatedImages/rocket_gen_img_1cac3c4b8-1768764885880.png"
          alt="Modern diagnostic center interior with reception desk, waiting area, and Indian medical staff in white coats at 51 Plus Lab Sector 51 Noida"
          fill
          className="object-cover object-center" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0c2d6b]/80 to-foreground" />
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="text-center">
            <div className="flex items-center justify-center gap-4 mb-3">
              <AppLogo size={88} className="drop-shadow-lg" />
              <div>
                <div className="text-white font-extrabold text-3xl leading-tight">51 Plus Lab</div>
                <div className="text-sky-300 text-sm font-semibold tracking-widest uppercase">NABL Accredited Diagnostics</div>
              </div>
            </div>
            <p className="text-white/70 text-sm">Noida&apos;s Most Trusted Diagnostic Lab · Sector 51, Noida</p>
          </div>
        </div>
      </div>
      {/* Main footer */}
      <div className="max-w-screen-2xl mx-auto px-6 lg:px-8 xl:px-10 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-10">
          {/* Brand column */}
          <div className="xl:col-span-1">
            <div className="flex items-center gap-2.5 mb-4">
              <AppLogo size={64} />
              <div>
                <div className="font-extrabold text-xl text-white leading-tight">51 Plus Lab</div>
                <div className="text-xs text-slate-400 font-medium">NABL Accredited Diagnostics</div>
              </div>
            </div>
            <p className="text-slate-300 text-sm leading-relaxed mb-5">
              Noida&apos;s trusted NABL-accredited diagnostic lab. Accurate reports,
              affordable prices, and home collection across all Noida sectors. Located at H-56, Sector 51, Noida.
            </p>
            <div className="space-y-2.5 mb-6">
              <a href="tel:+919818986535" className="flex items-center gap-2 text-sm text-slate-300 hover:text-white transition-colors">
                <Phone size={14} className="text-accent flex-shrink-0" />
                +91 98189 86535
              </a>
              <a href="tel:+917835819665" className="flex items-center gap-2 text-sm text-slate-300 hover:text-white transition-colors">
                <Phone size={14} className="text-accent flex-shrink-0" />
                +91 78358 19665
              </a>
              <a href="mailto:info@51pluslab.com" className="flex items-center gap-2 text-sm text-slate-300 hover:text-white transition-colors">
                <Mail size={14} className="text-accent flex-shrink-0" />
                info@51pluslab.com
              </a>
              <div className="flex items-start gap-2 text-sm text-slate-300">
                <Clock size={14} className="text-accent flex-shrink-0 mt-0.5" />
                Mon–Sun: 7:00 AM – 8:00 PM
              </div>
              <div className="flex items-start gap-2 text-sm text-slate-300">
                <MapPin size={14} className="text-accent flex-shrink-0 mt-0.5" />
                H-56, Sector 51, Noida, UP 201301
              </div>
            </div>
            <div className="flex items-center gap-3">
              {socialLinks?.map((social) =>
              <a
                key={`social-${social?.label}`}
                href={social?.href}
                className="w-8 h-8 rounded-lg bg-white/10 hover:bg-primary flex items-center justify-center transition-colors text-white"
                aria-label={social?.label}>
                  {social?.icon}
                </a>
              )}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-bold text-base mb-5 text-white">Quick Links</h4>
            <ul className="space-y-2.5">
              {quickLinks?.map((link) =>
              <li key={`footer-link-${link?.label}`}>
                  <Link
                  href={link?.href}
                  className="flex items-center gap-1.5 text-sm text-slate-300 hover:text-white hover:gap-2.5 transition-all">
                    <ArrowRight size={12} className="text-accent" />
                    {link?.label}
                  </Link>
                </li>
              )}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-bold text-base mb-5 text-white">Our Services</h4>
            <ul className="space-y-2.5">
              {services?.map((svc) =>
              <li key={`footer-svc-${svc}`}>
                  <Link
                  href="#"
                  className="flex items-center gap-1.5 text-sm text-slate-300 hover:text-white hover:gap-2.5 transition-all">
                    <ArrowRight size={12} className="text-accent" />
                    {svc}
                  </Link>
                </li>
              )}
            </ul>
          </div>

          {/* Our Branch */}
          <div>
            <h4 className="font-bold text-base mb-5 text-white">Our Branch — Noida</h4>
            <div className="space-y-4">
              {branches?.map((branch) =>
              <div key={`footer-branch-${branch?.name}`} className="flex items-start gap-2">
                  <MapPin size={14} className="text-accent flex-shrink-0 mt-0.5" />
                  <div>
                    <div className="text-sm font-medium text-white">{branch?.name}</div>
                    <div className="text-xs text-slate-400 leading-relaxed">{branch?.address}</div>
                  </div>
                </div>
              )}
            </div>
            {/* Google Maps link */}
            <div className="mt-4">
              <a
                href="https://www.google.com/maps/place/FIFTY+ONE+PLUS+LAB,+NOIDA,+ONE+PLUS+LAB+(Powered+by+BeLife)/@28.5786861,77.368656,17z"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-1.5 text-xs text-sky-400 hover:text-sky-300 transition-colors font-semibold">
                
                <MapPin size={12} />
                View on Google Maps →
              </a>
            </div>
            {/* Accreditation badges */}
            <div className="mt-6 pt-6 border-t border-white/10">
              <p className="text-xs text-slate-400 font-semibold uppercase tracking-wider mb-3">Accreditations</p>
              <div className="flex flex-wrap gap-2">
                {['NABL MC-6214', 'ISO 15189:2022', 'AERB Approved']?.map((badge) =>
                <span key={badge} className="text-xs bg-white/10 border border-white/15 text-slate-300 px-2.5 py-1 rounded-full font-medium">
                    {badge}
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Bottom bar */}
      <div className="border-t border-white/10">
        <div className="max-w-screen-2xl mx-auto px-6 lg:px-8 xl:px-10 py-4 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-slate-400">
          <div className="flex items-center gap-2">
            <AppLogo size={28} />
            <span>© 2026 51 Plus Lab. All rights reserved. NABL Accreditation No: MC-6214</span>
          </div>
          <div className="flex items-center gap-4">
            <Link href="#" className="hover:text-white transition-colors">Privacy Policy</Link>
            <Link href="#" className="hover:text-white transition-colors">Terms of Service</Link>
            <Link href="#" className="hover:text-white transition-colors">Refund Policy</Link>
          </div>
        </div>
      </div>
    </footer>);

}